

export default function NoChatNotice() {
  return (
    <div className="notice">
      <h2>Open from a chat</h2>
      <p>
        The calendar is per-group. Please open the Mini App from the chat menu of the group you want to use.
      </p>
    </div>
  );
}
